import get from 'lodash.get'
import { FC, ReactNode, useMemo } from 'react'
import { Control, useFormState } from 'react-hook-form'

interface ErrorMessageProps {
    control?: Control
    name: string
    pathPriority?: string[]
    render: (message: string) => ReactNode
}

const ErrorMessage: FC<ErrorMessageProps> = ({ control, name, pathPriority, render }) => {
    const state = useFormState({ control })

    const error = useMemo(() => {
        if (pathPriority) {
            const error = pathPriority.reduce<(typeof state.errors)[number] | null>(
                (error, path) => error ?? get(state.errors, `${name}.${path}`),
                null
            )

            if (error) return error
        }

        return state.errors[name]
    }, [state, name, pathPriority])

    if (typeof error?.message === 'string') return render(error.message)
}

export default ErrorMessage
